import {
  FLEXIGO_PUBLIC,
  FLEXIGO_V3,
  CORPORATE,
  PLANNER_CORPORATE,
  POOL,
  // FLEXIGO_LEGACY,
} from './base';

export const corporate = {
  requests: `${CORPORATE}/flexiride/requests`,
  multiRequests: `${CORPORATE}/flexiride/multi-requests`,
  editRequest: `${CORPORATE}/flexiride/requests/:requestId/update`,
  reasonList: `${CORPORATE}/flexiride/reasons`,
  assign: `${CORPORATE}/flexiride/requests/:requestId/assign`,
  assignableVehicles: `${CORPORATE}/flexiride/vehicles`,
  simulation: `${CORPORATE}/flexiride/moia/:simulationId`,
  updateVehicle: `${CORPORATE}/flexiride/requests/:requestId/updateVehicle`,
  priceModels: `${CORPORATE}/flexiride/available-poolcar-price-models`,
  requestStats: `${CORPORATE}/flexiride/stats`,
  users: `${CORPORATE}/members`,
  requestPlanning: `${CORPORATE}/poolcar/requests-planning`,
  planningVehicles: `${CORPORATE}/poolcar/vehicles`,
};

export const dashboard = {
  request: `${CORPORATE}/flexiride/dashboard/monitor/requests`,
  activatedRequests: `${CORPORATE}/flexiride/dashboard/monitor/activatedRequests`,
  summary: `${CORPORATE}/flexiride/dashboard/stats/summary`,
  byDate: `${CORPORATE}/flexiride/dashboard/stats/requests`,
  pickupOnTimePerformance: `${CORPORATE}/flexiride/dashboard/stats/on-time-pickups`,
  deliveryOnTimePerformance: `${CORPORATE}/flexiride/dashboard/stats/on-time-deliveries`,
  drivers: `${CORPORATE}/flexiride/dashboard/monitor/drivers`,
  vehicles: `${CORPORATE}/flexiride/dashboard/monitor/vehicles`,
  driverUtilization: `${CORPORATE}/flexiride/dashboard/stats/driver-utilization`,
  vehicleUtilization: `${CORPORATE}/flexiride/dashboard/stats/vehicle-utilization`,
  emissions: `${CORPORATE}/flexiride/dashboard/stats/emissions`,
};

const flexiride = {
  edit: `${FLEXIGO_PUBLIC}/flexiride/request-edit`,
  approve: `${FLEXIGO_PUBLIC}/flexiride/request-approve`,
  request: `${FLEXIGO_PUBLIC}/flexiride/request`,
  events: `${PLANNER_CORPORATE}/flexiride/calendar/events`,
  approveDraft: `${PLANNER_CORPORATE}/flexiride/calendar/resources/:resourceId/approve-draft`,
  recommendRoute: `${PLANNER_CORPORATE}/flexiride/calendar/recommend-route`,
  track: `${PLANNER_CORPORATE}/flexiride/track`,
  insertOrder: `${PLANNER_CORPORATE}/flexiride/calendar/insert-order`,
  moveOrder: `${PLANNER_CORPORATE}/flexiride/calendar/move-order`,
  // flexirideUsers: `${CORPORATE}/flexiride/members`,
  flexirideUsers: `${FLEXIGO_V3}/portal/personnels/flexiride-members`,
  sharedrideUsers: `${FLEXIGO_V3}/portal/personnels/sharedride-members`,
  optimization: {
    autoPlanAsync: `${PLANNER_CORPORATE}/flexiride/optimizations/auto-plan-async`,
    latestSolution: `${PLANNER_CORPORATE}/flexiride/optimizations/:optimizationId/latest-solution`,
    import: `${PLANNER_CORPORATE}/flexiride/optimizations/:optimizationId/import`,
  },
  saveExtend: `${PLANNER_CORPORATE}/orders/`,
  corporate, // left here for backward compatibility
  dashboard, // left here for backward compatibility
  pairRules: `${POOL}/flexiride/od/admin/pair-rules`,
};

export default flexiride;
